<template>

  <div class="demo-image__preview">
    <el-image style="width: 100px; height: 100px" :src="secUrl" :preview-src-list="[secUrl]">
    </el-image>
  </div>
</template>

<script>
export default {
  name: 'ELimage',
  props: { secUrl: String },
  data() {
    return {
    }
  }
}


</script>
